import { Typography, Grid } from "@mui/material";
import FormNumberField from "./FormNumberField";

interface RecurrenceProps {
  isEditing?: boolean;
  control: any;
}

export const DailyRecurrenceSelector = (props: RecurrenceProps) => {
  const { control, isEditing } = props;

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item>
        <Typography>Every</Typography>
      </Grid>
      <Grid item>
        <FormNumberField
          name="frequency"
          control={control}
          label=""
          readOnly={!isEditing}
        />
      </Grid>
      <Grid item>
        <Typography>day(s)</Typography>
      </Grid>
    </Grid>
  );
};
